module.exports = __webpack_public_path__ + "ab4ab9c49e37af5977082f93c72a8ed8.svg";